export const STATE_KEY = 'AMLCheckFormPage'
export const FORM_AML_CHECK_FORM = 'user_aml_check_form'

export const CONTENT_LOAD = 'Casino/AMLCheckFormPage/LOAD'
export const CONTENT_LOAD_SUCCESS = 'Casino/AMLCheckFormPage/LOAD_SUCCESS'
export const CONTENT_LOAD_ERROR = 'Casino/AMLCheckFormPage/LOAD_ERROR'
